<div class="user-interactions-block">
    <div class="user-interactions-header k-d-flex k-justify-content-between">
        <div class="title_heading">
            <h1>User Interactions</h1>
            <h2 class="h2-text">{{titleLable}}</h2>
        </div>
        <div class="btn-div">
           <button kendoButton class="btn " (click)="viewProduct()" [ngClass]="{'active':Isvariant}">View Product Variants</button>
           <button kendoButton class="btn" (click)="viewProduct()" [ngClass]="{'active':!Isvariant}">View Reports</button>
        </div>
   
    </div>
    <div class="k-d-flex  k-justify-content-stretch k-gap-3 k-w-full" >
        <ng-container *ngFor="let item of topUserInteractionsData; let i=index;">
        <div class="k-justify-content-center k-w-10">
            <div class="Card" [ngClass]="{'active':titleLable==item.label}">
                <div class="Card_Title Heading3">
                   {{item.label}}
                </div>
                <ng-container *ngIf="item?.mostAccessed!=''">
 
                    <div class="Card_Text">
                        <div>
                            Most Accessed: <a [routerLink]="['/Material-Details',item.mostAccessed]" [ngClass]="{'active-text':titleLable==item.label}"><b>{{item.mostAccessed}}</b></a>
                        </div>
                        <div>
                            Accessed: {{item.accessedCount}} times
                        </div>
                        <div>
                            By {{item.userEmail}}
                        </div>
                    </div>
                 
                </ng-container>
                <ng-container *ngIf="item?.mostAccessed==''">
                    <div class="Card_Text">
                        <div>
                            no pv acessed
                        </div>
                     </div>
                </ng-container>
                <div class="Card_Actions PH">
                    <div class="k-d-flex k-justify-content-center">
                       <a href="javascript:void(0)" (click)="showMore(item.label)" class="show_more">show more</a>
                    </div>
                </div>
            </div>
        </div>
        </ng-container>
    </div>
 
    <div class="filters-block">
        <form [formGroup]="frmuserInteractions" (ngSubmit)="onSubmit()">
            <div class="filters-block-content">
                <div class="w-370">
                        <kendo-textbox  class="input-text-filter"
                            placeholder="Search by Material Name or Material Type" #textbox
                            [clearButton]="true" formControlName="SearchTerm" [maxlength]="100">
                            <ng-template kendoTextBoxPrefixTemplate>
                                <fa-icon class="filter-text-icon" [icon]="iconPacks.FASEARCH"></fa-icon>
                            </ng-template>
                        </kendo-textbox>
                    </div>
                    <div class="w-280">
                <kendo-label class="k-display-none"
                  [for]="datepickerClassic">
                </kendo-label>
                <kendo-datepicker  class="input-text-filter-cal  k-w-10 abc "
                  #datepickerClassic
                  calendarType="classic"
                  [value]="value"
                  [(ngModel)]="kendoDate"
                  [format]="'yyyy/MM/dd'"
                    [placeholder]="'YYYY-MM-DD'"
                   formControlName="AccessedAt">
                </kendo-datepicker>
                </div>
               
                <div class="m-15-negative">
                    <button kendoButton class="btn-save k-button-lg ">Search</button>
                    <button type="button"  kendoButton class="btn-cancel k-button-lg" (click)="resetForm()">Reset</button>
                </div>
            </div>
        </form>
    </div>
       
        <ng-container *ngIf="!isChartShow">
           <ng-container *ngIf="!isLoading">
                    <kendo-grid class="mt-10" [data]="userInteractionsPVOrReportsTableData" [resizable]="true" [pageSize]="pageSize" [skip]="skip" 
                    [pageable]="{ info:true, previousNext: true }" (pageChange)="pageChange($event)">
                        <kendo-grid-column title="Material Name" field="materialName">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <a [routerLink]="['/Material-Details',dataItem.materialName]" [ngClass]="{ 'anchor': true }" >{{ dataItem.materialName }}</a>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="User Email" field="userEmail"></kendo-grid-column>
                        <kendo-grid-column title="Report Type" field="label"></kendo-grid-column>
                        <kendo-grid-column title="Acessed At" field="accessedAt">
                            <ng-template kendoGridCellTemplate let-dataItem >
                                <ng-container *ngIf="isToday(dataItem.accessedAt)">
                                    {{ dataItem.accessedAtFormatted }}
                                </ng-container>
                                <ng-container *ngIf="!isToday(dataItem.accessedAt)">
                                    {{ dataItem.accessedAt | dateFormatter:'dd MMM' }} ({{ dataItem.accessedAtFormatted }})
                                </ng-container>
                            </ng-template>
                        </kendo-grid-column>
                </kendo-grid>
            </ng-container>
        </ng-container>
 
        <ng-container *ngIf="isChartShow">
            <div class="empty-grid-msg-block">
                    Please select a filter criteria and press search button
            </div>
           
            <kendo-chart   [seriesColors]="['#E83E26', '#19C1DD', '#FFA319','#F3DA61']" (seriesClick)="onSeriesClick($event)">
                <kendo-chart-legend position="bottom"></kendo-chart-legend>
                <kendo-chart-area background="transparent"></kendo-chart-area>
                <kendo-chart-series>
                  <kendo-chart-series-item
                    type="pie"
                    field="count"
                    categoryField="label"
                    [data]="chartData"
                    >
                    <kendo-chart-series-item-tooltip>
                        <ng-template let-dataItem="dataItem">
                          {{dataItem.label}}: {{ dataItem.count }}
                        </ng-template>
                      </kendo-chart-series-item-tooltip>
                   </kendo-chart-series-item>
                 </kendo-chart-series>
              </kendo-chart>
        </ng-container>
          
</div>